<div class="modal fade" id="addModal" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1">
	<div class="modal-dialog">
		<div class="modal-content">
			<div class="modal-header mb-3">
				<button type="button" class="btn-close" (click)="dialogClose()"></button>
			</div>
			<div class="container text-center">
				<ul class="list-inline">
					<li class="list-inline-item" *ngFor="let item of columns">
						<button
							mat-raised-button
							class="mb-2"
							*ngIf="item.name && item.col !== 'number'"
							[color]="settings.hiddenColumns.includes(item.col) ? 'basic' : 'primary'"
							(click)="showHideRow(item.col, item.size)"
						>
							{{ item.name }}
						</button>
					</li>
				</ul>
			</div>
		</div>
	</div>
</div>
<mat-table
	#dataTable
	id="mat-table"
	[dataSource]="matData"
	matSort
	matSortDirection="asc"
	(matSortChange)="onSortChange($event)"
	class="mat-elevation-z4 mt-3 sizeTable"
>
	<ng-container *ngFor="let item of columns" [matColumnDef]="item.col">
		<mat-header-cell
			class="custom-header"
			*matHeaderCellDef
			mat-sort-header
			[disabled]="item?.disableSorting"
			[ngClass]="'max-w-' + [item?.size]"
			[ngStyle]="item?.extraStyle"
		>
			{{ item.name }}
		</mat-header-cell>
		<mat-cell *matCellDef="let element" [ngClass]="'max-w-' + [item?.size]" [ngStyle]="item?.extraStyle">
			@if (item.col === 'statusName') {
				<span
					class="badge"
					[ngClass]="{
						'bg-danger': element[item.col]?.statusColor === 'red',
						'bg-success': element[item.col]?.statusColor === 'green',
						'bg-primary': element[item.col]?.statusColor === 'blue',
					}"
				>
					{{ element[item.col]?.name }}</span
				>
			} @else if (item.col === 'transportTypes') {
				<span>
					@let array = removeDuplicates(element[item.col]);
					@for (kind of array; track kind) {
						<i class="fa-solid" [ngClass]="kind | transportKindIcon"></i>
					}
				</span>
			} @else if (!isArray(element[item.col]) && !element[item.col]?.isLink) {
				<span>{{ element[item.col] }}</span>
			} @else if (element[item.col]?.isLink) {
				<a [href]="element[item.col]?.route" target="_blank">{{ element[item.col].label }}</a>
			} @else if (isArray(element[item.col])) {
				<span>
					<!-- I don't want to refactor it cause I don't want to create any bug -->
					@let array = removeDuplicates(element[item.col]);
					@for (obj of array.slice(0, 1); track obj) {
						<span>
							{{ obj }}
							<span class="my-2">
								@if (array.length - 1 > 0) {
									<button
										class="mat-custom-editButton mx-2 my-2"
										mat-raised-button
										matTooltip="{{ array.slice(1) }} "
									>
										+{{ array.length - 1 }}
									</button>
								}
							</span>
						</span>
					}
				</span>
			}
		</mat-cell>
	</ng-container>
	<ng-container matColumnDef="columnShow">
		<mat-header-cell *matHeaderCellDef
			><button mat-icon-button [matMenuTriggerFor]="option">
				<mat-icon><i class="fa-solid fa-ellipsis-vertical"></i></mat-icon>
			</button>
			<mat-menu class="custom-mat-menu" #option="matMenu">
				<button mat-menu-item (click)="openDialog()">Widok kolumn<i class="fas fa-eye ms-2"></i></button>
				<button mat-menu-item (click)="copyReservations()">Skopiuj<i class="fas fa-clipboard ms-2"></i></button>
			</mat-menu>
		</mat-header-cell>
		<mat-cell *matCellDef="let element" class="justify-content-center"> </mat-cell>
	</ng-container>
	<mat-header-row *matHeaderRowDef="showColumns" class="mat-header-custom"></mat-header-row>
	<mat-row *matRowDef="let row; columns: showColumns; let i = index" [ngClass]="{ second: !(i % 2) }"></mat-row>
</mat-table>

<div id="no-results" class="mat-elevation-z4 py-5 text-center sizeTable" *ngIf="!matData.data.length">Brak wyników</div>

@if (allItemsSize() > 0) {
	<mat-paginator
		class="mat-elevation-z4 custom-left-mat-paginator"
		id="mat-paginator"
		(page)="pageChanged($event)"
		[pageSize]="50"
		[length]="allItemsSize()"
		[showFirstLastButtons]="false"
		showFirstLastButtons
	>
	</mat-paginator>
}
